export const  defaultformstate = {
    datasaved:false,
    savingdata:false,
    isSeasonSet:true,
    firstTimeLoad:true
}


// WEBPACK FOOTER //
// ./src/utils/statedefaultvalues/formstate.js